import {Injectable} from '@angular/core';
import {Observable} from 'rxjs/Rx';
import {NestApiProvider} from '../../nest-api';

@Injectable()
export class BankReportProvider {

  private _service: string = 'payroll';
  private _model: string = 'bankreport';

  constructor(
      private nestApiProvider: NestApiProvider,
  ) {
  }

  public downBankReport(filter: any): Observable<any> {
    const _method: string = 'POST';

    const _newModel: string = 'filegenerate';
    const _func: string = 'banktransferreportv2';
    const _params: any = filter;
    const _urlParams: any = {};
    const _body: any = {};

    const _url = this.nestApiProvider.urlBuilder(_method, _newModel, _func, _params, _urlParams, this._service);
    return this.nestApiProvider.requestBlobWithProgress(_method, _url, _params, _urlParams, _body);
  }

  public downloadFormatBank(filter: any): Observable<any> {
    const _method: string = 'GET';
    const _func: string = 'downloadFormatBank';
    const _params: any = {};
    const _urlParams: any = {};
    const _body: any = {};

    if (typeof filter !== 'undefined' && filter !== null) _urlParams.filter = filter;

    const _url = this.nestApiProvider.urlBuilder(_method, this._model, _func, _params, _urlParams, this._service);
    return this.nestApiProvider.requestBlobWithProgress(_method, _url, _func, _params, _body);
  }

  public createDisbursement(data: any): Observable<any> {
    const _method: string = 'POST';
    const _func: string = 'setAutoTrans';
    const _params: any = data;
    const _urlParams: any = {};
    let _body: any = {};

    const _url = this.nestApiProvider.urlBuilder(_method, this._model, _func, {}, _urlParams, this._service);
    return this.nestApiProvider.request(_method, _url, _params, _urlParams, _body);
  }

  public cancelDisbursment(periodCode: any, payDate: any): Observable<any> {
    const _method: string = 'GET';
    const _func: string = 'cancelDisbursement';
    const _params: any = {};
    const _urlParams: any = {};
    let _body: any = {};

    if (typeof periodCode !== 'undefined' && periodCode !== null) _urlParams.periodCode = periodCode;
    if (typeof payDate !== 'undefined' && payDate !== null) _urlParams.payDate = payDate;

    const _url = this.nestApiProvider.urlBuilder(_method, this._model, _func, {}, _urlParams, this._service);
    return this.nestApiProvider.request(_method, _url, _params, _urlParams, _body);
  }

  public closedDisbursement(periodCode: any, payDate: any): Observable<any> {
    const _method: string = 'GET';
    const _func: string = 'closedDisbursement';
    const _params: any = {};
    const _urlParams: any = {};
    const _body: any = {};

    if (typeof payDate !== 'undefined' && payDate !== null) _urlParams.payDate = payDate;
    if (typeof periodCode !== 'undefined' && periodCode !== null) _urlParams.periodCode = periodCode;

    const _url = this.nestApiProvider.urlBuilder(_method, this._model, _func, {}, _urlParams, this._service);
    return this.nestApiProvider.request(_method, _url, _params, _urlParams, _body);
  }

  public infoDisbursement(periodCode: any, payDate: any): Observable<any> {
    const _method: string = 'GET';
    const _func: string = 'infoDisbursement';
    const _params: any = {};
    const _urlParams: any = {};
    const _body: any = {};

    if (typeof payDate !== 'undefined' && payDate !== null) _urlParams.payDate = payDate;
    if (typeof periodCode !== 'undefined' && periodCode !== null) _urlParams.periodCode = periodCode;

    const _url = this.nestApiProvider.urlBuilder(_method, this._model, _func, {}, _urlParams, this._service);
    return this.nestApiProvider.request(_method, _url, _params, _urlParams, _body);
  }
}



// WEBPACK FOOTER //
// ./src/shared/nestjs/payroll/bank-report/bank-report.ts